export enum ErrorCode {
    E403_001 = 'E403_001', ///UNDER_REVIEW
    E403_002 = 'E403_002', ///PERMISSION_DENIED
}